<div *ngIf="isCommentTextInputVisible" class="p-inputgroup section-comment">
  <p-editor
    [(ngModel)]="comment"
    class="text-area"
    [readonly]="!isCommentSaveVisible"
    [style]="{ height: '50px' }"
    (onTextChange)="textChanged($event)"
    #tabOne
    (onInit)="editorOnInit($event)">
    <p-header>
      <span class="ql-formats">
        <button class="ql-bold" aria-label="Bold"></button>
        <button class="ql-italic" aria-label="Italic"></button>
        <button class="ql-underline" aria-label="Underline"></button>
      </span>
    </p-header>
  </p-editor>

  <button
    *ngIf="isCommentSaveVisible"
    (click)="saveComment()"
    class="save-comment-button"
    type="button"
    pButton
    icon="pi pi-check"></button>
  <button
    *ngIf="!isCommentSaveVisible"
    (click)="confirm()"
    class="ui-button-danger"
    type="button"
    pButton
    icon="pi pi-times"
    [disabled]="isCommentDeleteButtonDisabled"></button>
  <p-confirmDialog icon="pi pi-exclamation-triangle"></p-confirmDialog>
</div>
<div *ngIf="isCommentTextVisible && comment" class="ordnance-warning display-comment" [innerHTML]="comment"></div>
